import { Box, TextField, Typography} from "@mui/material"
import { MapManagePlan } from "../../../components/Table/mapping-function/TableMapping";
import { PackageTable } from "../../../components/Table/component/PackageTable";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setPlanForView } from "../../../Slices/planslice";
import http from "../../../utils/http-common";
import { toast } from "react-toastify";
import { FilterIkn, OffIkn, OnIkn, SearchIcon } from "../../../utils/icon/Private-Pages/Icon";
    
export const ManagePlan = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [tableData, setTableData] = useState(MapManagePlan([]));
    const [page, setPage] = useState(1);
    const [rowsPerPage] = useState(10);
    const dispatch = useDispatch()
    const [threedotss, setThreeDotss] = useState(true);

useEffect(()=> {
    const getPlan = async () => {
    try {
      const response = await http.post(
        "/master_service/admin/plan/list"
      );
      const data = response.data.data.map((i) => ({
        id: i.id,
        plan_id: i.plan_id.toString(),
        plan_name: i.plan_name,
        created_by: i.created_by,
        createdAt: new Date(i.createdAt).toLocaleDateString('en-GB', {
          day: 'numeric',
          month: 'short',
          year: 'numeric'
        }),
        users_associated: i.user_count
      }));
      setTableData(MapManagePlan(data));
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };
  getPlan();
}, [])

    useEffect(() => {
        dispatch(setPlanForView({ id: 43, isView: true, table: false }));
    })
    const filteredData = tableData.filter((i) => [i?.plan_id, i?.plan_name, i?.created_by, i?.createdAt, i?.user_count]?.some(field =>
        String(field ?? '').toLowerCase().includes(searchTerm.toLowerCase())
    ));
    const prop = {
        borderBoxStyle: { px: 0 },
        goto: true,
        filteredData: filteredData,
        titleStyle: { fontSize: '20px', fontWeight: '600', color: '#000', },
        tableStyle: { OutBox: { borderRadius: "8px", borderBottomLeftRadius: 0, borderBottomRightRadius: 0, }, },
        rowsPerPage,
        page,
        setPage
    }
    return (
        <Box sx={{ width: '100%', }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Typography sx={{ color: '#000000', fontSize: '20px', fontWeight: '600' }}>Manage Plan</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', border: '0.8px solid #797F8F80', borderRadius: '4px', padding: '0rem 1rem', width: '100%', height: '35px', maxWidth: '250px', }}>
                        <SearchIcon sx={{ color: '#757575', marginRight: '0.5rem' }} />
                        <TextField sx={{ flex: 1, '& .MuiOutlinedInput-root': { lineHeight: '35px', height: '35px', '& fieldset': { border: 'none', height: '35px', }, '&:hover fieldset': { border: 'none', }, '&.Mui-focused fieldset': { border: 'none', }, }, }} placeholder='Search...' variant='outlined' value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                    </Box>
                </Box>
            </Box>
            <PackageTable prop={prop} />
        </Box>
    )
}